// Lib
import { LOCATION_CHANGE } from 'react-router-redux';

const initialState = {
    locationBeforeTransitions: null,
};

/**
 * From react-router-redux source:
 *
 * This reducer will update the state with the most recent location history
 * has transitioned to. This may not be in sync with the router, particularly
 * if you have asynchronously-loaded routes, so reading from and relying on
 * this state it is discouraged.
 */
export default function routerReducer(state = initialState, action) {
    if (action.type === LOCATION_CHANGE) {
        return {
            ...state,
            locationBeforeTransitions: action.payload,
        };
    }
    return state;
}
